exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-question-conversation-chat-btn{position:fixed;z-index:2147483003;bottom:20px;right:20px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;background:#333;cursor:pointer;box-shadow:0 1px 6px 0 rgba(0,0,0,.06),0 2px 32px 0 rgba(0,0,0,.16)}.question-conversation-chat{width:28rem;position:fixed !important;right:-28rem;top:0;height:100%}@media screen and (max-width: 576px){.question-conversation-chat{width:100%;right:-100%}}.question-conversation-content{font-size:.9rem}.show-question-conversation{animation:show-question-conversation .8s forwards}.hide-question-conversation{animation:hide-question-conversation .8s forwards}@keyframes show-question-conversation{0%{transform:translateX(0%)}100%{transform:translateX(-100%)}}@keyframes hide-question-conversation{0%{transform:translateX(-100%)}100%{transform:translateX(0%)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/question-conversation/questionconversation.scss
// module id = 5369
// module chunks = 0